import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbdSortableHeader, SortEvent } from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { PartsBusinessService } from '../../../business-services/parts.service';
import { PartSalesPriceCalculation, PartSalesPriceCalculationResultModel } from '../../../business-entities/dealer-parts-list-view-model';
import { BrandService } from '../../../business-services/brand.service';
import { BrandType } from '../../../business-entities/vehicle-list-view-model';
import { PaymentMasterService } from '../../../business-services/payment-master.service';

@Component({
  selector: 'app-part-sales-price-calculation',
  templateUrl: './part-sales-price-calculation.component.html'
})
export class PartSalesPriceCalculationComponent implements OnInit {

  //#region Variable and constructor declaration and intialization

  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  partPriceList: PartSalesPriceCalculationResultModel[] = [];
  totalCount: number = 0;
  throttle = 100;
  scrollDistance = 1;
  debounceTimer : any;
  searchTerm: string;
  makeList: BrandType[] = [];
  laborAndItemSalesPriceList:any;
  brandCode:string = null;
  itemSalesPriceGroup:string = null;
  constructor(
    private spinner: NgxSpinnerService,
    private partsService: PartsBusinessService,
    private brandService: BrandService,
    private paymentService: PaymentMasterService,
  ) { }

  //#endregion

  //#region Components methods

  ngOnInit(): void {
    this.GetAllMake();
    this.GetLaborandItemSalesPriceGroup();
    if (this.brandCode != undefined) {
      this.partsService.partSalesPriceCalculationRequestmodel.makeCode = this.brandCode;
    }
    if (this.itemSalesPriceGroup != undefined) {
      this.partsService.partSalesPriceCalculationRequestmodel.itemSalesPriceGroup = this.itemSalesPriceGroup;
    }
    this.partsService.partSalesPriceCalculationRequestmodel.searchTearm = '';
    this.partsService.partSalesPriceCalculationRequestmodel.startRecordNumber = 0;
    this.partPriceList = [];
    this.GetPartSalesPriceList(this.partsService.partSalesPriceCalculationRequestmodel);
  }
  async GetLaborandItemSalesPriceGroup() {
    await this.paymentService.GetLaborandItemSalesPriceGroup().then((response) => {
      this.laborAndItemSalesPriceList = response.responseObject;
    });
  }

  async GetAllMake(): Promise<void> {
    await this.brandService.GetBrandDropdown().then(data => {
      this.makeList = data.responseObject;
      });
  }
  ItemSalesPriceGroupChange(status: any) {
    if (status == undefined) {
      this.partsService.partSalesPriceCalculationRequestmodel.itemSalesPriceGroup = null;
    } else {
      this.partsService.partSalesPriceCalculationRequestmodel.itemSalesPriceGroup = status.$ngOptionLabel.trim();
    }
    this.partsService.partSalesPriceCalculationRequestmodel.startRecordNumber = 0;
    this.partPriceList = [];
    this.GetPartSalesPriceList(this.partsService.partSalesPriceCalculationRequestmodel);
  }

  ItemMakeCodeChange(status: any) {
    if (status == undefined) {
      this.partsService.partSalesPriceCalculationRequestmodel.makeCode = null;
    } else {
      this.partsService.partSalesPriceCalculationRequestmodel.makeCode =  status.$ngOptionLabel.trim();
    }
    this.partsService.partSalesPriceCalculationRequestmodel.startRecordNumber = 0;
    this.partPriceList = [];
    this.GetPartSalesPriceList(this.partsService.partSalesPriceCalculationRequestmodel);
  }

  async onSort({ column, direction }: SortEvent) {
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.partsService.partSalesPriceCalculationRequestmodel.sortColumn = column;
    this.partsService.partSalesPriceCalculationRequestmodel.sortDirection = direction;
    this.partsService.partSalesPriceCalculationRequestmodel.startRecordNumber = 0;
    this.partPriceList = [];
    await this.GetPartSalesPriceList(this.partsService.partSalesPriceCalculationRequestmodel);
  }
  onEnterPress() {
    this.debounceFunction(() => this.onSearchFilter(), 500);
  }
  async onSearchFilter() {
    this.partsService.partSalesPriceCalculationRequestmodel.searchTearm = this.searchTerm;
    this.partsService.partSalesPriceCalculationRequestmodel.startRecordNumber = 0;
    this.partPriceList = [];
    this.GetPartSalesPriceList(this.partsService.partSalesPriceCalculationRequestmodel);
  }

  debounceFunction(func, delay) {
    window.clearTimeout(this.debounceTimer);
    this.debounceTimer = window.setTimeout(func, delay);
  }

  loadMoreData(event) {
    this.debounceFunction(() => this.onScrollDown(event), 200);
  }


  onScrollDown(_ev) {
    if (this.totalCount > this.partPriceList.length) {
      this.partsService.partSalesPriceCalculationRequestmodel.startRecordNumber = this.partPriceList.length
      this.GetPartSalesPriceList(this.partsService.partSalesPriceCalculationRequestmodel);
    }
  }

  //#endregion

  //#region Api methods
  async GetPartSalesPriceList(_partRequestModel : PartSalesPriceCalculation) {
    this.spinner.show();
    await this.partsService.GetPartSalesPriceList(this.partsService.partSalesPriceCalculationRequestmodel).then(res => {
        if (res.responseObject.length > 0) {
          this.partPriceList.push(...res.responseObject);
          this.totalCount = res.responseObject[0].totalCount;
        }
        else{
          this.spinner.hide();
        }     
    }).finally(() => {
      this.spinner.hide();
    });
  }
  //#endregion


}
